<template>
  <div class="custom-content">
    <user-component>
      <a-form
        style="width: 100%;"
        id="formLogin"
        class="user-layout-login"
        ref="formLogin"
        :form="form"
        @submit="handleSubmit"
      >
        <a-tabs
          v-model="loginType"
          @change="handleTabClick"
          :tabBarStyle="{'border-bottom': '0px solid #e8e8e8','text-align': 'center'}">
          <a-tab-pane tab="密码登录" :key="1">
            <a-form-item style="margin-bottom: 16px">
              <a-input
                size="large"
                type="text"
                placeholder="绑定邮箱/注册时填写的手机号"
                v-decorator="['accountNumber', {rules: [{ required: true,validator: handleUsernameOrEmail }], validateTrigger: 'change,blur'}]">
                <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }"/>
              </a-input>
            </a-form-item>
            <a-form-item style="margin-bottom: 4px">
              <a-input
                size="large"
                type="password"
                autocomplete="false"
                placeholder="请输入密码"
                v-decorator="[
                'password',
                {rules: [{ required: true, message: '请输入密码' }], validateTrigger: 'blur'}
              ]"
              >
                <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }"/>
              </a-input>
            </a-form-item>
          </a-tab-pane>
          <a-tab-pane tab="短信登录" :key="2">
            <a-form-item style="margin-bottom: 16px">
              <a-input size="large" type="text" placeholder="手机号"
                       v-decorator="['accountNumber', {rules: [{ required: true, pattern: /^1[34578]\d{9}$/, message: '请输入正确的手机号' }], validateTrigger: 'change'}]">
                <a-icon slot="prefix" type="mobile" :style="{ color: 'rgba(0,0,0,.25)' }"/>
              </a-input>
            </a-form-item>
            <a-row :gutter="16">
              <a-col class="gutter-row" :span="16">
                <a-form-item style="margin-bottom: 4px">
                  <a-input size="large" type="text" placeholder="短信验证码"
                           v-decorator="['verification', {rules: [{ required: true, message: '请输入验证码' }], validateTrigger: 'blur'}]">
                    <a-icon slot="prefix" type="mail" :style="{ color: 'rgba(0,0,0,.25)' }"/>
                  </a-input>
                </a-form-item>
              </a-col>
              <a-col class="gutter-row" :span="8">
                <a-button
                  class="getCaptcha"
                  tabindex="-1"
                  :disabled="state.smsSendBtn"
                  @click.stop.prevent="getCaptchaEvent"
                  v-text="!state.smsSendBtn && '获取验证码' || (state.time+' s')"
                ></a-button>
              </a-col>
            </a-row>
          </a-tab-pane>
        </a-tabs>
        <a-form-item style="margin-bottom: 10px">
          <a-checkbox
            v-model="rememberMe"
          >自动登录
          </a-checkbox>
          <router-link
            :to="{ name: 'resetPassword'}"
            class="forge-password"
            style="float: right;"
          >忘记密码
          </router-link>
        </a-form-item>
        <a-form-item style="margin-bottom: 10px">
          <a-button
            size="large"
            type="primary"
            htmlType="submit"
            class="login-button"
            :loading="saveLoading"
            :disabled="saveLoading"
          >登录
          </a-button>
        </a-form-item>
        <div class="user-login-other">
          <a-checkbox v-model="agreement">已阅读并同意</a-checkbox>
          <a @click="showAgreementEvent">《用户使用协议》</a>
          <router-link v-if="!excludeRegistration" class="register" :to="{ name: 'register' }">注册账户</router-link>
        </div>
      </a-form>
    </user-component>
    <user-agreement-dialog :visible="showAgreementDialog" @close="showAgreementDialog=false"></user-agreement-dialog>
    <image-code-component
      :visible="visible"
      @close="visible=false"
      @confirm="onImageCodeConfirm"
    ></image-code-component>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapActions } from 'vuex'
import { timeFix } from '@/utils/util'
import formMixin from '../../utils/mixins/formMixins'
import passwordMixins from '@/utils/mixins/passwordMixins'
import userHelper from '../../utils/helper/userHelper'
import UserComponent from './components/UserComponent'
import UserAgreementDialog from '@/views/user/components/UserAgreementDialog'
import ImageCodeComponent from '@/views/user/components/ImageCodeComponent'

export default {
  mixins: [formMixin, passwordMixins],
  components: { UserComponent, UserAgreementDialog, ImageCodeComponent },
  data() {
    return {
      loginType: 1,
      showAgreementDialog: false,
      rememberMe: false,
      agreement: true,
      excludeRegistration: true
    }
  },
  activated() {
    this.loginType = 1
    this.agreement = true
    this.resetForm()
  },
  mounted() {
    this.excludeRegistration = this.getPlatformConfig().excludeRegistration
    this.agreement = true
    if (this.loginType === 1) {
      const accountNumber = Vue.ls.get('accountNumber')
      // const password = Vue.ls.get('password')
      this.rememberMe = Vue.ls.get('rememberMe')
      this.getLogUtils().logWithTag('==accountNumber===', accountNumber)
      this.$nextTick(() => {
        this.form.setFieldsValue({ accountNumber: accountNumber })
      })

      // if (this.rememberMe && accountNumber && password) {
      //   //自动登录
      //   setTimeout(() => this.requestLogin({accountNumber:accountNumber, password:password}), 1000)
      // }
      this.restImageCodeUrl()
    }
  },
  methods: {
    ...mapActions(['Login', 'Logout']),
    handleTabClick(key) {
      this.loginType = key
    },

    showAgreementEvent() {
      this.showAgreementDialog = true
    },
    handleSubmit(e) {
      e.preventDefault()
      const validateFieldsKey = this.loginType === 1 ? ['accountNumber', 'password'] : ['accountNumber', 'verification']
      this.validateFormParams(validateFieldsKey)
        .then(values => {
          if (!this.agreement) {
            this.$message.error('登录前必须仔细阅读 并且同意用户使用协议')
            return
          }
          if (this.rememberMe) {
            Vue.ls.set('accountNumber', values.accountNumber)
            // Vue.ls.set('password', userHelper.getPasswordEncrypt(values.password))
            Vue.ls.set('rememberMe', this.rememberMe)
          } else {
            Vue.ls.remove('accountNumber')
            // Vue.ls.remove('password')
            Vue.ls.remove('rememberMe')
          }
          this.requestLogin(values)
        }).catch(reason => this.getLogUtils().errorWithTag('handleSubmit', reason))
    },
    onImageCodeConfirm(imageParams) {
      this.visible = false
      const accountNumber = this.form.getFieldProps('accountNumber').props.value
      this.requestCaptcha(accountNumber, imageParams)
    },

    requestLogin(values) {
      this.saveLoading = true
      let verification = values.verification
      if (this.loginType === 1) {
        verification = userHelper.getPasswordEncrypt(values.password)
        if (verification.length === values.password.length) {
          //原始长度跟MD5后的长度一致，说明原来的是MD5后的密码
          verification = values.password//替换密码
        }
      }
      const params = {
        accountNumber: values.accountNumber,
        verification: verification,
        type: this.loginType//登录方式 1密码登录 2短信登录 ,
      }
      this.Login(params)
        .then(res => {
          const redirect = this.$route.query.redirect
          if (redirect) {
            let redirectUrl = decodeURIComponent(redirect)
            if (redirectUrl.includes('supplyChain/')) {
              if (redirectUrl.includes('?')) {
                redirectUrl = redirectUrl + '&token=' + res.token
              } else {
                redirectUrl = redirectUrl + '?token=' + res.token
              }
            }
            window.location.href = decodeURIComponent(redirectUrl)
          } else {
            this.loginSuccess(res)
          }
        }).catch(reason => this.showNetWorkErrorMessage(reason))
        .finally(() => this.saveLoading = false)
    },

    loginSuccess(res) {
      this.$router.push({ name: 'home' })
      // 延迟 1 秒显示欢迎信息
      setTimeout(() => {
        this.$notification.success({
          message: '欢迎',
          description: `${timeFix()}，欢迎回来`
        })
      }, 1000)
    },
    getCaptchaEvent(e) {
      e.preventDefault()
      const { form: { validateFields } } = this
      validateFields(['accountNumber'], { force: true }, (err, values) => {
        if (!err) {
          this.visible = true
        }
      })
    }
  }

}
</script>

<style lang="less" scoped>
.custom-content {
  margin: 0 auto; /*水平居中*/
}

.img-code {
  width: 110px;
  height: 40px;
}

.user-layout-login {
  label {
    font-size: 14px;
  }

  .getCaptcha {
    display: block;
    width: 100%;
    height: 40px;
  }

  .forge-password {
    font-size: 14px;
  }

  button.login-button {
    padding: 0 15px;
    font-size: 16px;
    height: 40px;
    width: 100%;
  }

  .user-login-other {
    text-align: left;
    line-height: 22px;

    .item-icon {
      font-size: 24px;
      color: rgba(0, 0, 0, 0.2);
      margin-left: 16px;
      vertical-align: middle;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: #FAAD14;
      }
    }

    .register {
      float: right;
    }
  }
}
</style>
